import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: ${({ theme }) =>
    theme.isMobile ? `calc(100dvh - 6.4rem)` : '100dvh'};
  width: 100%;
  padding-right: ${({ theme }) => theme.spacing(0.5)};
`;

export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(1.5)} ${theme.spacing(2)} ${theme.spacing(2)}`};
  min-width: 0;
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  border: ${({ theme }) => `1px solid ${theme.palette.grey[400]}`};
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(4)};
  box-shadow: ${({ theme }) => theme.shadowBox.contentBlock};

  overflow: hidden;
`;

export const SidePanel = styled.div`
  height: 100%;
  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(1.5)} ${theme.spacing(2)} 0`};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `}

  overflow: hidden;
`;

export const SidePanelContent = styled.div<{ $open: boolean }>`
  height: 100%;

  border: ${({ theme, $open }) =>
    $open ? `1px solid ${theme.palette.grey[400]}` : 'none'};

  box-shadow: ${({ theme }) => theme.shadowBox.contentBlock};
  border-radius: ${({ theme }) => theme.spacing(4)};
  overflow: hidden;
`;
